import React from "react";
import Box from "@mui/material/Box";
import { CustomButton } from "../../../../../components/customButton/CustomButton";

export function TabMonitoreoHeader({ setOpenDialog, ultimoEstadoPendiente }) {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <h3>Monitoreos</h3>
      <Box display="flex" gap="20px">
        <CustomButton
          disabled={!!ultimoEstadoPendiente}
          label={"Agregar Monitoreo"}
          onClick={() => !ultimoEstadoPendiente && setOpenDialog()}
        />
      </Box>
    </Box>
  );
}
